import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5cc26e7d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "carousel"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_title = _resolveComponent("c-title");
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_title, {
    title: "系统展示"
  }), _createVNode(_component_el_carousel, {
    type: "card",
    height: "300px"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$dic.carousel[_ctx.$route.name], item => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: item
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: item,
          class: "carousel-img"
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]);
}